import { render, staticRenderFns } from "./OrderStatusDelivered.vue?vue&type=template&id=2e5d7384&"
import script from "./OrderStatusDelivered.vue?vue&type=script&lang=js&"
export * from "./OrderStatusDelivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports